import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Typography, useTheme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { fetchLanguages } from "../../../redux/actions";
import { languageListSelector } from "../../../redux/selectors";
import LanguageRow from "./LanguageRow";

export default ({ currentLanguage, onLanguageChange }) => {
  const languages = useSelector(languageListSelector, shallowEqual);

  const dispatch = useDispatch();
  const theme = useTheme();
  const intl = useIntl();

  const getBackgroundColor = (language) => {
    if (language.id == currentLanguage) {
      return theme.palette.secondary.A600;
    } else {
      return "#fff";
    }
  };

  const getFontColor = (language) => {
    if (language.id == currentLanguage) {
      return "#fff";
    } else {
      return "#000";
    }

    return "#000";
  };

  const getBorderColor = (language) => {
    if (language.id == currentLanguage) {
      return theme.palette.primary.A800;
    } else {
      return "#fff";
    }
  };
  useEffect(() => {
    dispatch(fetchLanguages());
  }, []);

  return (
    <Paper>
      <Grid container direction="column" style={{ width: "100%" }}>
        <Grid
          item
          style={{
            width: "100%",
            borderBottom: "solid 1px rgba(0,0,0,0.5)",
            minHeight: "100px",
            padding: "0 11px 0 20px",
          }}
        >
          <Grid
            container
            justify="space-between"
            alignItems="center"
            style={{ minHeight: "100px" }}
          >
            <Grid item>
              <Typography
                variant="subtitle1"
                data-testid="testid-language-label"
              >
                {intl.formatMessage({ id: "app.survey.languageLabel" })}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column">
            {languages &&
              languages
                .filter((d) => d.id === 1)
                .map((r) => (
                  <Grid
                    item
                    style={{
                      padding: "0 11px 0 20px",
                      backgroundColor: getBackgroundColor(r),
                      color: getFontColor(r),
                      borderLeft: `solid 4px ${getBorderColor(r)}`,
                      borderBottom: "solid 1px black",
                      cursor: "pointer",
                    }}
                    onClick={() => onLanguageChange(r.id)}
                    key={r.id}
                  >
                    <LanguageRow
                      language={r}
                      onLanguageChange={onLanguageChange}
                    />
                  </Grid>
                ))}
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column">
            {languages &&
              languages
                .filter((d) => d.id != 1)
                .sort((a, b) => {
                  return a.label < b.label ? -1 : 1;
                })
                .map((r) => (
                  <Grid
                    item
                    style={{
                      padding: "0 11px 0 20px",
                      backgroundColor: getBackgroundColor(r),
                      color: getFontColor(r),
                      borderLeft: `solid 4px ${getBorderColor(r)}`,
                      borderBottom: "solid 1px black",
                      cursor: "pointer",
                    }}
                    key={r.id}
                    onClick={() => onLanguageChange(r.id)}
                  >
                    <LanguageRow language={r} />
                  </Grid>
                ))}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};
